export default "__VITE_ASSET__CqXm4hWP__"